import loadTopicsLogic from "./loadTopicsLogic";
//import getTopicLogic from "./getTopicLogic";
//import getTopicFailLogic from "./getTopicFailLogic";
//import getTopicSuccessLogic from "./getTopicSuccessLogic";
//import createTopicLogic from "./createTopicLogic";

export default [
	...loadTopicsLogic,
	//...getTopicLogic,
	//...getTopicFailLogic,
	//...getTopicSuccessLogic,
	//...createTopicLogic,
];
